import accmant from './accmant'

export { accmant }